import React, { FC } from 'react'
import styles from 'styles/components/header.module.scss'
import { useDispatch } from 'react-redux'
import { goBack } from 'connected-react-router'

const HeaderMenuBack: FC = () => {
  const dispatch = useDispatch()
  return (
    <button className={styles.header__menu__back} onClick={() => dispatch(goBack())}>
      <img src={'/icon/menu/back.svg'} alt={'前のページに戻る'} />
    </button>
  )
}

export default HeaderMenuBack
